<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إنشاء طلب صيانة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/orders">الصيانة</router-link></li>
              <li class="breadcrumb-item active">إنشاء طلب</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <successAlert v-if="hasSuccess" :message="successMessage" />

            <div class="card card-secondary card-outline mb-4">
              <div class="card-header"><div class="card-title">بيانات طلب الصيانة</div></div>
              <div class="card-body">

                <div class="mb-3">
                  <label class="form-label">العميل <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <input type="text" v-model="clientMobile" class="form-control"
                      placeholder="أدخل رقم جوال العميل" @keyup.enter="searchClient">
                    <button class="btn btn-outline-secondary" type="button" @click="searchClient" :disabled="clientSearching">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                  <div v-if="clientSearching" class="mt-2 text-muted small">جاري البحث...</div>
                  <div v-if="foundClient" class="mt-2 p-2 bg-light rounded border">
                    <i class="bi bi-person-check-fill text-success me-1"></i>
                    <strong>{{ foundClient.name }}</strong> — {{ foundClient.mobile }}
                    <button class="btn btn-sm btn-outline-danger ms-2" @click="clearClient">
                      <i class="bi bi-x"></i>
                    </button>
                  </div>
                  <div v-if="clientNotFound" class="mt-2 text-danger small">
                    <i class="bi bi-exclamation-circle"></i> لم يتم العثور على العميل
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">نوع المشكلة <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="issueId">
                    <option :value="null">اختر نوع المشكلة</option>
                    <option v-for="issue in issues" :key="issue.id" :value="issue.id">{{ issue.name }}</option>
                  </select>
                </div>

                <div class="mb-3">
                  <label class="form-label">نوع الطلب <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="orderType">
                    <option value="normal">عادي</option>
                    <option value="fast">سريع</option>
                    <option value="mosque">مسجد</option>
                    <option value="global">عام</option>
                  </select>
                </div>

                <div class="mb-3">
                  <label class="form-label">وصف المشكلة <span class="text-danger">*</span></label>
                  <input type="text" v-model="title" class="form-control" >
                </div>

                <div class="mb-3">
                  <label class="form-label">كود الخصم</label>
                  <div class="input-group">
                    <input type="text" v-model="coupon" class="form-control">
                    <button class="btn btn-outline-warning" type="button" @click="applyCoupon" :disabled="couponChecking">
                      {{ couponChecking ? '...' : 'تطبيق' }}
                    </button>
                  </div>
                  <div v-if="couponMsg" class="mt-1 small" :class="couponValid ? 'text-success' : 'text-danger'">
                    {{ couponMsg }}
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">وصف شامل للمشكلة <span class="text-danger">*</span></label>
                  <textarea v-model="description" class="form-control" rows="4"></textarea>
                </div>

                <div class="mb-3">
                  <label class="form-label">أرفق صور المشكلة</label>
                  <input ref="photosInput" type="file" accept="image/*" class="form-control" @change="onPhotosChange">
                  <div class="row mt-2 g-2" v-if="photoPreviews.length">
                    <div class="col-4 col-md-2" v-for="(src, i) in photoPreviews" :key="i">
                      <div class="position-relative">
                        <img :src="src" class="img-thumbnail w-100" style="height:80px;object-fit:cover;">
                        <button class="btn btn-danger btn-sm position-absolute top-0 end-0 p-0 px-1"
                          @click="removePhoto" style="font-size:10px;">x</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label">الموقع <span class="text-danger">*</span></label>
                  <div ref="orderMap" style="width: 100%; height: 350px; border-radius: 8px; border: 1px solid #dee2e6;"></div>
                  <div class="row mt-2">
                    <div class="col-6">
                      <label for="">خط الطول </label>
                      <input type="text" class="form-control form-control-sm text-center" :value="longitude" readonly placeholder="خط الطول">
                    </div>
                    <div class="col-6">
                      <label for="">خط العرض </label>
                      <input type="text" class="form-control form-control-sm text-center" :value="latitude" readonly placeholder="خط العرض">
                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer text-end">
                <router-link to="/orders" class="btn btn-light me-2">إلغاء</router-link>
                <button class="btn btn-primary" @click="submitForm" :disabled="submitting">
                  <span v-if="submitting"><i class="fa-solid fa-spinner fa-spin me-1"></i>جاري الإنشاء...</span>
                  <span v-else><i class="bi bi-plus-circle me-1"></i>إنشاء الطلب</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'OrdersCreate',
  data() {
    return {
      submitting: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      successMessage: '',
      errorNumber: 0,
      clientMobile: '',
      clientSearching: false,
      foundClient: null,
      clientNotFound: false,
      issueId: null,
      orderType: 'normal',
      title: '',
      description: '',
      coupon: '',
      couponChecking: false,
      couponValid: false,
      couponMsg: '',
      latitude: 24.7136,
      longitude: 46.6753,
      map: null,
      marker: null,
      photos: [],
      photoPreviews: [],
      issues: [],
    };
  },
  computed: {
    ...mapGetters(['GOOGLE_MAP_API']),
  },
  methods: {
    async searchClient() {
      if (!this.clientMobile) return;
      this.clientSearching = true;
      this.clientNotFound  = false;
      this.foundClient     = null;
      try {
        const { data } = await this.$http.get(`/api/admin/users/list?mobile=${this.clientMobile}`);
        if (data.rows && data.rows.length) {
          this.foundClient = data.rows[0];
        } else {
          this.clientNotFound = true;
        }
      } catch (_) { this.clientNotFound = true; }
      this.clientSearching = false;
    },
    clearClient() {
      this.foundClient = null;
      this.clientMobile = '';
      this.clientNotFound = false;
    },
    async applyCoupon() {
      if (!this.coupon) return;
      this.couponChecking = true;
      this.couponMsg = '';
      this.couponValid = false;
      try {
        const { data } = await this.$http.post('/api/admin/coupons/check', { coupon: this.coupon });
        if (data.status === 'success') {
          this.couponValid = true;
          this.couponMsg = 'تم تطبيق كود الخصم بنجاح';
        } else {
          this.couponMsg = 'كود الخصم غير صحيح';
        }
      } catch (_) {
        this.couponMsg = 'كود الخصم غير صحيح';
      }
      this.couponChecking = false;
    },
    onPhotosChange(e) {
      const file = e.target.files[0];
      this.photos = file ? [file] : [];
      this.photoPreviews = file ? [URL.createObjectURL(file)] : [];
    },
    removePhoto() {
      this.photos = [];
      this.photoPreviews = [];
      if (this.$refs.photosInput) this.$refs.photosInput.value = null;
    },
    initMap() {
      if (!this.$refs.orderMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error('Google Maps API is not loaded.');
        return;
      }
      const center = { lat: this.latitude, lng: this.longitude };
      this.map = new google.maps.Map(this.$refs.orderMap, {
        center,
        zoom: 10,
      });
      this.marker = new google.maps.Marker({
        position: center,
        map: this.map,
        draggable: true,
      });
      this.marker.addListener('dragend', (event) => {
        this.latitude  = parseFloat(event.latLng.lat().toFixed(6));
        this.longitude = parseFloat(event.latLng.lng().toFixed(6));
      });
      this.map.addListener('click', (event) => {
        const pos = event.latLng;
        this.marker.setPosition(pos);
        this.latitude  = parseFloat(pos.lat().toFixed(6));
        this.longitude = parseFloat(pos.lng().toFixed(6));
      });
    },
    initialGoogleMap() {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    async submitForm() {
      this.hasError   = false;
      this.hasSuccess = false;

      if (!this.foundClient)
        return this.showError('يجب اختيار عميل');
      if (!this.issueId)
        return this.showError('يجب اختيار نوع المشكلة');
      if (!this.orderType)
        return this.showError('يجب اختيار نوع الطلب');
      if (!this.title || this.title.length < 2)
        return this.showError('يجب إدخال وصف المشكلة');
      if (!this.description || this.description.length < 2)
        return this.showError('يجب إدخال الوصف الشامل للمشكلة');
      if (!this.latitude || !this.longitude)
        return this.showError('يجب تحديد الموقع على الخريطة');

      this.submitting = true;
      const fd = new FormData();
      fd.append('userId',      this.foundClient.id);
      fd.append('issueId',     this.issueId);
      fd.append('orderType',   this.orderType);
      fd.append('title',       this.title);
      fd.append('description', this.description);
      fd.append('latitude',    this.latitude);
      fd.append('longitude',   this.longitude);
      if (this.coupon) {
        fd.append('coupon', this.coupon);
      }
      if (this.photos.length) {
        fd.append('image', this.photos[0]);
      }

      try {
        const { data } = await this.$http.post('/api/admin/orders/create', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        toast('تم إنشاء طلب الصيانة بنجاح', 'success');
        this.$router.push(`/orders/update/${data.row.id}`);
      } catch (err) {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      this.submitting = false;
    },
    showError(msg) {
      this.message  = msg;
      this.hasError = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async loadFormData() {
      try {
        const { data } = await this.$http.get('/api/admin/mIssues/list');
        this.issues = data.rows || [];
      } catch (_) {}
    },
  },
  created() {
    this.loadFormData();
    this.initialGoogleMap();
  },
};
</script>